module.exports = __webpack_public_path__ + "fonts/weathericons-regular-webfont.1cd48d78.woff2";